import { ChangeDetectorRef, Component, ElementRef, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CompilationModel } from '../../../../../@models/erp/compilation';
import { CompilationTypeData, PaymentDates, UnitData } from '../../../../../@models/erp/compilationData';
import { IDropdownOptions, SharedDataService } from '../../../../../@core/service/shared-data.service';
import { TreeService } from '../../../../../@core/service/tree.service';
import { NrkWindowComponent } from '../../../shared/nrk-window/nrk-window.component';
import { ApiService } from '../../../../../@core/service/api.service';
import { mongoId } from '../../../../../@core/common/global';
import { ActivityContentModel, ActivityModel, BusinessModel, EActivityContentType, ProjectModel, ProjectSummaryContentModel } from '../../../../../@models';
import { NbDialogService, NbPopoverComponent, NbPopoverDirective, NbToastrService } from '@nebular/theme';
import saveAs from 'file-saver';
import { DownloadConfig } from '../../../document/document-printer/document-printer.component';
import { AuthGuardService } from '../../../../../@core/service/auth-guard.service';
import { CommonDialogComponent, NrkDialogType } from '../../../shared/common-dialog/common-dialog.component';
import moment from 'moment';

@Component({
  selector: 'ngx-internal-updates',
  templateUrl: './internal-updates.component.html',
  styleUrls: ['./internal-updates.component.css'],
})
export class InternalUpdatesComponent implements OnInit {

  api = inject(ApiService);
  data = inject(SharedDataService);
  tree = inject(TreeService);
  cdr = inject(ChangeDetectorRef);
  toastr = inject(NbToastrService);
  dialogService = inject(NbDialogService);
  auth = inject(AuthGuardService);

  @ViewChild('window') window: NrkWindowComponent;
  @ViewChild('contentDiv') contentDiv: ElementRef<HTMLElement>;

  @Input() linked = true;
  @Input() print = false;
  @Output() updated = new EventEmitter<CompilationModel>();

  unitData = UnitData;
  typeData = CompilationTypeData;

  doc: CompilationModel;
  projectOffers: (Partial<CompilationModel> & { product: string, totalNet: string })[];
  modifiedProjects: ProjectModel[] = [];
  paymentDates = PaymentDates.getOptions();
  business: BusinessModel = null;
  allProjectOptions: IDropdownOptions[];
  projectOptions: IDropdownOptions[] = [];
  showAllProjectsChecked = false

  srStatus: string = ''

  internalUpdatesSnapshotData = '';

  constructor() {}

  ngOnInit(): void {
    this.data.loadBusinesses();
    this.data.loadBusinessUnits();
    this.data.loadProducts();
  }

  async open(doc) {
    return this.init(doc, true);
  }

  async init(doc, openWindow = false) {
    this.doc = this.linked ? await this.tree.getLinkedOcAsync(doc.code ?? doc) : doc;
    if (openWindow) { 
      this.internalUpdatesSnapshot();
      this.window.open(this.doc);
    }
    // console.log('InternalUpdatesComponent', this.doc);
    this.business = this.data.businesses.find(f => mongoId(f) === mongoId(this.doc.recipient));
    this.business?.projects?.forEach(el => el.businessUnit = this.data.businessUnits.find(f => mongoId(f) === mongoId(el.businessUnit)))
    if (this.business) this.business.projects = this.business.projects.filter(f => f.active);
    // this.projectOptions = this.business.projects.map(m => ({ id: m._id, name: m.name }));
    // if (this.doc.projectRemark?.projects) {
    //   this.doc.projectRemark.projects = this.doc.projectRemark.projects.map(m => 
    //     this.business.projects?.find(f => mongoId(f) === mongoId(m))
    //   )?.filter(f => notNull => notNull);
    // }
    this.loadProjectOptions();

    const ofcodes = this.business?.projects?.flatMap(m => m.offers?.length ? m.offers : m.offer ).filter(notNull => notNull);
    this.projectOffers = [];
    for (let code of ofcodes) {
      const offer = await this.api.loadCompilationByCode(code);
      console.log('load offer with code', code, offer);
      if (!this.projectOffers.find(f => f.code === offer.code)) this.projectOffers.push({
        ...offer,
        product: offer.lineItems[0]?.finishedProduct?.calcName ?? '',
        totalNet: this.data.calcData(offer)?.totalNet ?? '',
      })
    }
    // console.log('open doc', doc, this.doc);
    this.srStatus = (await this.api.getSrStatus(this.doc.code))?.statusStr;
  }

  loadProjectOptions() {
    if (this.showAllProjectsChecked) {
      if (!this.allProjectOptions) {
        this.api.projects().subscribe((p: any) => {
          this.allProjectOptions = p
            .map(m => ({id: mongoId(m), name: `${this.data.businesses.find(f => mongoId(f) === mongoId(m.business))?.name} | ${m.sales} | ${m.name}`}))
            .sort((a, b) => (a.name || '').localeCompare(b.name))
          console.log('all projects', this.projectOptions);
          this.projectOptions = [...this.allProjectOptions]
        })
      } else {
        this.projectOptions = [...this.allProjectOptions];
      }
    } else {
      this.projectOptions = this.business.projects.map(m => ({ id: m._id, name: `${m.name}` }));
      if (this.doc.projectRemark?.projects) {
        this.doc.projectRemark.projects = this.doc.projectRemark.projects.map(m => 
          this.business.projects?.find(f => mongoId(f) === mongoId(m))
        )?.filter(f => notNull => notNull);
      }
      console.log('business project options', this.projectOptions);
    }
  }

  internalUpdatesSnapshot() {
    this.internalUpdatesSnapshotData = JSON.stringify({
      remarks: {
        ...this.doc.projectRemark,
        projects: this.doc.projectRemark?.projects.map(m => mongoId(m)),
      },
      notInSrReprot: this.doc.notInSrReport,
    })
  }

  checkForInternalUpdates() {
    const data = JSON.stringify({
      remarks: {
        ...this.doc.projectRemark,
        projects: this.doc.projectRemark?.projects.map(m => mongoId(m)),
      },
      notInSrReprot: this.doc.notInSrReport,
    })
    if (data !== this.internalUpdatesSnapshotData) {
      if (confirm('Save changes?')) {
        this.updateInternalUpdates(this.doc)
      } else {
        const res = JSON.parse(this.internalUpdatesSnapshotData);
        this.doc.projectRemark = res.remarks;
        this.doc.notInSrReport = res.notInSrReprot;
      }
    }
  }

  generateProjectSummaryActivity(doc: CompilationModel, response: any): ActivityModel {
    const firstPoDate = moment(this.doc.projectRemark.expectedFirstPoDate).format('YYYY-MM-DD')
    const activity = new ActivityModel();
    activity.business = doc.recipient;
    activity.title = doc.sampleRequest ? 'SR set completed' : 'Project completed';
    activity.date = moment().toDate();
    activity.location = doc.sampleRequest ? `SR - ${response.srResult === 2 ? 'no ' : ''}commercial release` : 'Project';
    activity.purpose = this.doc.customerDocumentNumber + '\n'
      + (firstPoDate && doc.sampleRequest ? `Date of first PO: ${firstPoDate}\n` : '')
      + this.doc.lineItems?.map(m => m?.finishedProduct?.calcName)?.join('\n') + '\n\n'
      + response?.text;
    activity.content = new ProjectSummaryContentModel();
    (activity.content as ProjectSummaryContentModel).docCode = doc.code;
    return activity
  }

  async updateInternalUpdates(ref: CompilationModel, finalize = false) {

    console.log('updateInternalUpdates', ref, finalize);

    const update = async (response = undefined) => {
        const doc = await this.api.loadCompilationByCode(ref.code);
        let activity = undefined;
        doc.internalUpdates = ref.internalUpdates;
        doc.projectRemark = ref.projectRemark;
        console.log('finalize', finalize, ref.projectCompleted, response)
        if (finalize) {
          doc.projectCompleted = ref.projectCompleted = !ref.projectCompleted;
          if (response.srResult === 1) {
            doc.projectRemark.expectedFirstPoDate = ref.projectRemark.expectedFirstPoDate = response.expectedFirstPoDate;
          }
          if (doc.projectCompleted) {
            this.srStatus = 'Completed';
            if (response.showInNews) {
              activity = this.generateProjectSummaryActivity(doc, response);
            }
          }
        }
        doc.notInSrReport = ref.notInSrReport;
        if (response?.text) {
          ref.projectRemark?.items.unshift({
            date: new Date(),
            user: this.auth.user?.short,
            category: 'Summary',
            text: response.text,
            files: [],
          })
          doc.projectRemark = ref.projectRemark;
        }
        if (response?.srResult) {
          doc.srResult = ref.srResult = response.srResult;
        }
        await this.api.saveCompilation(doc);
        console.log('save activity', activity, response);
        if (activity) this.api.saveActivity(activity);
        for (const proj of this.modifiedProjects) {
          await new Promise((resolve) => this.api.saveProject(proj).subscribe(s => resolve(true)));
        }

    }

    await new Promise(async res => {
      if (finalize) {
        this.dialogService.open(CommonDialogComponent, {
          context: {
            dialogType: NrkDialogType.srProjectComplete,
            compilation: ref,
          },
        }).onClose.subscribe(async data => {
          console.log(data);
          if (data?.response?.text
            && (
              ((ref.sampleRequest)
              && (data.response.srResult || ref.projectCompleted) 
              && (data.response.expectedFirstPoDate || data.response.srResult === 2 || ref.projectCompleted)
            )
            || !ref.sampleRequest
            )
          ) {
            await update(data.response);
          } else {
            if (!data?.response?.text) this.toastr.danger('No summary entered', 'Entry required');
            if (ref.sampleRequest && !data.response.srResult && !ref.projectCompleted)this.toastr.danger('No SR result entered', 'Entry required');
            if (ref.sampleRequest && !data.response.expectedFirstPoDate && data.response.srResult === 1) this.toastr.danger('No expected first purchase date entered', 'Entry required');
          }
          res(true);
        });
      } else {
        console.log('plain update')
        await update();
        res(true);
      }
    })

    if (this.linked) {
      this.doc = await this.tree.getLinkedOcAsync(ref.code);
      this.internalUpdatesSnapshot();
      this.updated.emit(ref);
    }
    this.cdr.detectChanges();
    // console.log('updateInternalUpdates - finalize', finalize, this.doc.projectCompleted, this.doc);
    if (finalize && this.doc.projectCompleted) {
      this.generatePDF();
    }
  }

  onOfSelected(idx: number, offer: CompilationModel) {
    console.log('onOfSelected', idx, offer);
    const project = this.api.getProject(mongoId(this.doc.projectRemark?.projects[idx]));
    // const project = this.doc.projectRemark?.projects[idx];
    if (!project.offers?.includes(offer.code)) project.offers.push(offer.code);
    this.api.saveProject(project).subscribe(() => {
      this.init(this.doc, false);
    })
  }

  onProjectSelected(projectId: ProjectModel) {
    const project = this.business?.projects?.find(f => mongoId(f) === mongoId(projectId));
    console.log('project selected:', project)
    if (project) {
      this.doc.projectRemark?.projects?.unshift(project);
      console.log('project selected: remark', this.doc.projectRemark);
    }
  }

  removeProject(idx: number) {
    this.doc.projectRemark?.projects?.splice(idx, 1);
  }

  async generatePDF() {

    this.print = true;
    const pdfName = `${moment().format('YYMMDD')}_`
     + `${this.data.getBusinessName(this.doc.recipient)}_`
     + `${this.doc.customerDocumentNumber}_`
     + `${this.doc.lineItems[0]?.finishedProduct?.calcName}_`
     + `${this.srStatus}`;
    console.log('generate PDF start')
    console.time('generatePDF');
    await new Promise((res) => { // await change detection
      setTimeout(() => res(true));
    })
    // await new Promise((res) => { // await change detection (2nd cycle)
    //   setTimeout(() => res(true));
    // })
    console.timeEnd('generatePDF');
    console.log('generate PDF end')

    const head = `
      <head>
        <style>
          body {
            margin: 0;
            padding: 0;
            font-family: Pero, Verdana, Arial;
          }
          h5 {
            font-size: 20pt;
            padding: 3rem 0 1rem 0;
            margin: 0;
          }
          .sample-status {
            padding: 0 0 1rem 0;
          }
          .info-segment-new {
            margin-bottom: 5mm;
          }

          .info-segment-new ul {
            display: table;
            table-layout: fixed;
            border-collapse: collapse; /* Removes extra spacing */
            padding: 0;
            margin: 0;
          }

          .info-segment-new li {
            display: table-cell;
            vertical-align: top;
            padding-right: 1rem;
          }

          .info-segment-new td {
            margin: 0;
            padding: 0;
          }

          .layout-label, .label {
            font-size: smaller;
            color: gray;
            padding-right: 0.5rem;
          }
          .section-header {
            font-weight: bold;
            font-size: 1.1rem;
            padding-top: 1rem;
            padding-bottom: 0.5rem;
          }

          .profit-layout-table th, .profit-layout-table td {
            border: 0;
            margin: 0;
            padding: 0 2rem 0 0;
            text-align: left;
          }
          .profit-layout-table tr:first-child td {
            font-size: smaller;
            color: gray;
            line-height: 0.8rem;
          }

          ::ng-deep .out-of-report label {
            color: black !important;
          }

          .nrk-table {
            border: 1px solid lightgray;
          }
          .nrk-table th { background-color: lightgray; padding: 0.5rem; }
          .nrk-table td { padding-top: 0.5em; }
          .nrk-table tr:last-child > td { padding-bottom: 0.5em; }

        </style>
      </head>
    `

    const html =  
      `<html>${head}<body>
          ${this.contentDiv.nativeElement.innerHTML}
        </body></html>
      `
      
    const config = new DownloadConfig();
    // config.css = 'document-printer.css';
    config.footer = `
      <!DOCTYPE html>
      <html>

      <head>
        <script>
          function subst() {
            var vars = {};
            var query_strings_from_url = document.location.search.substring(1).split('&');
            for (var query_string in query_strings_from_url) {
              if (query_strings_from_url.hasOwnProperty(query_string)) {
                var temp_var = query_strings_from_url[query_string].split('=', 2);
                vars[temp_var[0]] = decodeURI(temp_var[1]);
              }
            }
            var css_selector_classes = ['page', 'frompage', 'topage', 'webpage', 'section', 'subsection', 'date', 'isodate', 'time', 'title', 'doctitle', 'sitepage', 'sitepages'];
            for (var css_class in css_selector_classes) {
              if (css_selector_classes.hasOwnProperty(css_class)) {
                var element = document.getElementsByClassName(css_selector_classes[css_class]);
                for (var j = 0; j < element.length; ++j) {
                  element[j].textContent = vars[css_selector_classes[css_class]];
                }
              }
            }
          }
        </script>
      </head>

      <body style="border:0; margin: 2rem 0 2rem 0;" onload="subst()">
        <div style="border-top: 1px solid #a70240; width: 100%;font-size:11pt; padding: 0.5rem 0 0 0">
          <table style="width: 100%">
            <tr>
              <td>Date: ${new Date().toISOString().replace(/T.*/, '')}<td>
              <td style="text-align:center">${pdfName}</td>
              <td style="text-align:right">
                Page <span class="page"></span> of <span class="topage"></span>
              </td>
            </tr>
          </table>
        </div>
      </body>

      </html>`;   
    config.html = html
    config.orientation = 'portrait';

    // console.log('html', html)

    await new Promise(resolve => this.api.getDocumentFile('/api/v1/compilation/pdf', config).subscribe(async res => {
      saveAs(res, pdfName);
      this.print = false;
    }));
    

  }

  removeOffer(offer: any) {
    this.business?.projects?.forEach(proj => {
      if (proj?.offer === offer.code) {
        proj.offer = undefined;
        this.modifiedProjects.push(proj);
      } else {
        proj.offers = proj.offers.filter(f => f !== offer.code);
        this.modifiedProjects.push(proj);
      }
    })
    this.init(this.doc, false);
  }

//   async updateInternalUpdates(ref: CompilationModel, finalize = false) {

//     console.log('updateInternalUpdates', ref, finalize);

//     const update = async (response = undefined) => {
//         const doc = await this.api.loadCompilationByCode(ref.code);
//         doc.internalUpdates = ref.internalUpdates;
//         // doc.profitMarginText = ref.profitMarginText;
//         doc.projectRemark = ref.projectRemark;
//         // doc.projectCompleted = finalize ? !ref.projectCompleted : ref.projectCompleted;
//         if (finalize) {
//           doc.projectCompleted = ref.projectCompleted = !ref.projectCompleted;
//           if (response.srResult === 1) {
//             doc.projectRemark.expectedFirstPoDate = response.expectedFirstPoDate;
//           }
//         }
//         // if (finalize) {
//         //   doc.notInSrReport = ref.notInSrReport = doc.projectCompleted;
//         // } else {
//         //   doc.notInSrReport = ref.notInSrReport;
//         // }
//         doc.notInSrReport = ref.notInSrReport;
//         if (response?.text) {
//           ref.projectRemark?.items.unshift({
//             date: new Date(),
//             user: this.auth.user?.short,
//             category: 'Summary',
//             text: response.text,
//             files: [],
//           })
//           doc.projectRemark = ref.projectRemark;
//         }
//         if (response?.srResult) {
//           doc.srResult = response.srResult;
//         }
//         // console.log('------------------>', ref, doc.projectRemark, doc)
//         await this.api.saveCompilation(doc);
//         // if (fromReport) {
//         //   this.loadInternalUpdataData(ref);
//         //   this.reloadData(true, false);
//         // }
//     }

//     if (finalize) {
//       this.dialogService.open(CommonDialogComponent, {
//         context: {
//           dialogType: NrkDialogType.srProjectComplete,
//           compilation: ref,
//         },
//       }).onClose.subscribe(async data => {
//         // console.log('-------------------------->', data, data?.response?.text, data?.response?.srResult, data?.response?.text && (data.response.srResult || ref.projectCompleted))
//         if (data?.response?.text 
//           && (data.response.srResult || ref.projectCompleted) 
//           && (data.response.expectedFirstPoDate || data.response.srResult === 2)
//         ) {
//           await update(data.response);
//         } else {
//           if (!data?.response?.text) this.toastr.danger('No summary entered', 'Entry required');
//           if (!data.response.srResult && !ref.projectCompleted)this.toastr.danger('No SR result entered', 'Entry required');
//           if (!data.response.expectedFirstPoDate && data.response.srResult === 1) this.toastr.danger('No expected first purchase date entered', 'Entry required');
//         }
//       });
//     } else {
//       console.log('plain update')
//       await update();
//     }

//     if (this.linked) {
//       this.doc = await this.tree.getLinkedOcAsync(ref.code);
//       this.internalUpdatesSnapshot();
//       this.updated.emit(ref);
//     }

//   }

}